import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { StoreType } from "client/store"

export const EmptySpan = styled.span`
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: grey !important;
`

export const Empty = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.empty}
        </EmptySpan>
    )
}

export const NotUsed = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.notUsed}
        </EmptySpan>
    )
}

export const NoDatapoints = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.noDatapoints}
        </EmptySpan>
    )
}

export const InsufficientData = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.insufficientData}
        </EmptySpan>
    )
}

export const NotCompliant = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.notCompliant}
        </EmptySpan>
    )
}

export const DraftSaved = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.draftSaved}
        </EmptySpan>
    )
}

export const NotAvailable = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <EmptySpan>
            {lang.notAvailable}
        </EmptySpan>
    )
}
